/***************************************************************************/
"use client";
/***************************************************************************/

import React from "react";
import { ButtonGroup } from "../button-group";
import { Toast } from "./toast";
import { ToastClose } from "./toast-close";
import { ToastDescription } from "./toast-description";
import {
  ToastDangerIcon,
  ToastInfoIcon,
  ToastSuccessIcon,
  ToastWarningIcon,
} from "./toast-icon";
import { ToastProvider } from "./toast-provider";
import { ToastTitle } from "./toast-title";
import { ToastViewport } from "./toast-viewport";
import { useToast } from "./use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        icon,
        title,
        description,
        action,
        ...props
      }) {
        return (
          <Toast key={id} {...props}>
            {title && (
              <div className="w-full flex flex-row justify-between items-center gap-1">
                <ToastTitle className="flex flex-row gap-2">
                  {!icon && (
                    <React.Fragment>
                      {props.variant === "success" && <ToastSuccessIcon />}
                      {props.variant === "info" && <ToastInfoIcon />}
                      {props.variant === "warning" && <ToastWarningIcon />}
                      {props.variant === "error" && <ToastDangerIcon />}
                    </React.Fragment>
                  )}
                  {icon}
                  <span>{title}</span>
                </ToastTitle>
                <ToastClose />
              </div>
            )}
            {description && (
              <div className="w-full flex flex-row justify-between gap-1">
                <ToastDescription>{description}</ToastDescription>
                {!title && <ToastClose />}
              </div>
            )}
            {action && (
              <ButtonGroup gap="sm" className="items-center">
                {action}
              </ButtonGroup>
            )}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
